import React from 'react';
import { forceCheck } from 'react-lazyload';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import Icon from '../../common/styles/Icon';
import { SimpleCarouselWrapper } from './SimpleCarousel.style';

interface Props {
  children: React.ReactNode;
  onChangeSlides: (to: number) => void;
  slidesToScrollConfig?: {
    desktop?: number;
    smallDesktop?: number;
    tablet?: number;
    small?: number;
  };
  onClickEditorsPicksCarousel?: () => void;
  onClickRecommendedLocationCarouselArrow?: () => void;
}

function SimpleCarousel(props: Props): React.ReactElement {
  const {
    children,
    onChangeSlides,
    slidesToScrollConfig = {},
    onClickEditorsPicksCarousel,
    onClickRecommendedLocationCarouselArrow,
  } = props;

  const {
    desktop = 3,
    smallDesktop = 2,
    tablet = 2,
    small = 1,
  } = slidesToScrollConfig;

  const settings = {
    dots: false,
    draggable: false,
    infinite: false,
    adaptiveHeight: true,
    useCSS: true,
    slidesToShow: desktop,
    slidesToScroll: desktop,
    variableWidth: true,
    prevArrow: <Icon iconName="arrow-left" />,
    nextArrow: <Icon iconName="arrow-right" />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToScroll: smallDesktop,
          slidesToShow: smallDesktop,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          draggable: true,
          slidesToScroll: tablet,
          slidesToShow: tablet,
        },
      },
      {
        breakpoint: 768,
        settings: {
          draggable: true,
          slidesToScroll: small,
          slidesToShow: small,
        },
      },
    ],
  };

  const handleSlideChange = (from: number, to: number) => {
    onChangeSlides(to);
    forceCheck();
  };

  return (
    <SimpleCarouselWrapper
      data-test="simple-carousel"
      onClick={() => {
        onClickEditorsPicksCarousel?.();
        onClickRecommendedLocationCarouselArrow?.();
      }}
    >
      <Slider {...settings} beforeChange={handleSlideChange}>
        {children}
      </Slider>
    </SimpleCarouselWrapper>
  );
}

export default SimpleCarousel;
